function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { StyledButtonIcon } from './ButtonIcon.style';
import PropTypes from 'prop-types';
import { getCleanProps } from '../../utility/getCleanProps';
var componentId = 'ButtonIcon';
ButtonIcon.propTypes = {
  /** aria-label of the button */
  label: PropTypes.string.isRequired,

  /** variant of the button */
  color: PropTypes.oneOf(['black', 'primary', 'white']).isRequired,

  /** icon of the button that will show beside the label. usage: <ButtonIcon label="label" icon={AddIcon} /> */
  icon: PropTypes.func.isRequired,

  /** renders the right color on a dark background */
  isOnDarkBg: PropTypes.bool,

  /** type of the button */
  type: PropTypes.oneOf(['button', 'submit', 'reset']),

  /** callback when the button is clicked */
  onClick: PropTypes.func,

  /** ref for the button */
  buttonRef: PropTypes.shape({
    current: PropTypes.any
  }),

  /** reference of the native button element */
  ref: PropTypes.func,

  /** a list of element id (separated by a space) that describes this button */
  'aria-describedby': PropTypes.string
};
ButtonIcon.componentId = componentId;
ButtonIcon.defaultProps = {
  color: 'black',
  type: 'button'
};
export function ButtonIcon(props) {
  var label = props.label,
      color = props.color,
      icon = props.icon,
      buttonRef = props.buttonRef,
      restProps = _objectWithoutProperties(props, ["label", "color", "icon", "buttonRef"]);

  var Icon = icon;
  return /*#__PURE__*/React.createElement(StyledButtonIcon, _extends({}, getCleanProps(restProps), {
    variant: color,
    "aria-label": label,
    "data-component-id": componentId,
    ref: buttonRef
  }), /*#__PURE__*/React.createElement(Icon, {
    "aria-hidden": "true",
    focusable: "false"
  }));
}